const translation = {
  pageTitle: 'เฮ้ มาเริ่มกันเลย!',
  welcome: '👋 ยินดีต้อนรับสู่ Dify โปรดเข้าสู่ระบบเพื่อดําเนินการต่อ',
  email: 'ที่อยู่อีเมล',
  emailPlaceholder: 'อีเมลของคุณ',
  password: 'รหัสผ่าน',
  passwordPlaceholder: 'รหัสผ่านของคุณ',
  name: 'ชื่อผู้ใช้',
  namePlaceholder: 'ชื่อผู้ใช้ของคุณ',
  forget: 'ลืมรหัสผ่านใช่ไหม',
  signBtn: 'เข้าสู่ระบบ',
  continueWithCode: 'ดําเนินการต่อด้วยรหัส',
  sendVerificationCode: 'ส่งรหัสยืนยัน',
  usePassword: 'ใช้รหัสผ่าน',
  useVerificationCode: 'ใช้รหัสยืนยัน',
  or: 'หรือ',
  installBtn: 'สถาปนา',
  setAdminAccount: 'การตั้งค่าบัญชีผู้ดูแลระบบ',
  setAdminAccountDesc: 'สิทธิ์สูงสุดสําหรับบัญชีผู้ดูแลระบบ ซึ่งสามารถใช้สร้างแอปพลิเคชันและจัดการผู้ให้บริการ LLM เป็นต้น',
  createAndSignIn: 'สร้างและลงชื่อเข้าใช้',
  oneMoreStep: 'อีกหนึ่งขั้นตอน',
  createSample: 'จากข้อมูลนี้ เราจะสร้างแอปพลิเคชันตัวอย่างสําหรับคุณ',
  invitationCode: 'รหัสเชิญ',
  invitationCodePlaceholder: 'รหัสเชิญของคุณ',
  interfaceLanguage: 'ภาษาอินเทอร์เฟซ',
  timezone: 'เขตเวลา',
  go: 'ไปที่ Dify',
  sendUsMail: 'ส่งอีเมลถึงเรา แล้วเราจะจัดการกับคําขอเชิญ',
  acceptPP: 'ฉันได้อ่านและยอมรับนโยบายความเป็นส่วนตัวแล้ว',
  reset: 'โปรดเรียกใช้คําสั่งต่อไปนี้เพื่อรีเซ็ตรหัสผ่านของคุณ',
  withGitHub: 'ดําเนินการต่อด้วย GitHub',
  withGoogle: 'ดําเนินการต่อกับ Google',
  withSSO: 'ดําเนินการต่อด้วย SSO',
  rightTitle: 'ปลดล็อกศักยภาพของ LLM อย่างเต็มที่',
  rightDesc: 'สร้างแอปพลิเคชัน AI ที่ดึงดูดสายตา ใช้งานได้ และปรับปรุงได้อย่างง่ายดาย',
  tos: 'ข้อกําหนดในการให้บริการ',
  pp: 'นโยบายความเป็นส่วนตัว',
  tosDesc: 'การลงทะเบียนแสดงว่าคุณยอมรับ',
  goToInit: 'หากคุณยังไม่ได้เริ่มต้นบัญชี โปรดไปที่หน้าการเริ่มต้น',
  dontHave: 'ไม่มี?',
  invalidInvitationCode: 'รหัสเชิญไม่ถูกต้อง',
  accountAlreadyInited: 'บัญชีเริ่มต้นแล้ว',
  forgotPassword: 'ลืมรหัสผ่านใช่ไหม',
  resetLinkSent: 'รีเซ็ตลิงก์ที่ส่ง',
  sendResetLink: 'ส่งลิงก์รีเซ็ต',
  backToSignIn: 'กลับไปที่การลงชื่อเข้าใช้',
  forgotPasswordDesc: 'โปรดป้อนที่อยู่อีเมลของคุณเพื่อรีเซ็ตรหัสผ่านของคุณ เราจะส่งอีเมลพร้อมคําแนะนําเกี่ยวกับวิธีการรีเซ็ตรหัสผ่านของคุณ',
  checkEmailForResetLink: 'โปรดตรวจสอบอีเมลของคุณเพื่อหาลิงก์สําหรับรีเซ็ตรหัสผ่านของคุณ หากไม่ปรากฏขึ้นภายใน 2-3 นาที โปรดตรวจสอบโฟลเดอร์สแปมของคุณ',
  passwordChanged: 'ลงชื่อเข้าใช้ตอนนี้',
  changePassword: 'ตั้งรหัสผ่าน',
  changePasswordTip: 'โปรดป้อนรหัสผ่านใหม่สําหรับบัญชีของคุณ',
  changePasswordBtn: 'ตั้งรหัสผ่าน',
  invalidToken: 'โทเค็นไม่ถูกต้องหรือหมดอายุ',
  confirmPassword: 'ยืนยันรหัสผ่าน',
  confirmPasswordPlaceholder: 'ยืนยันรหัสผ่านใหม่ของคุณ',
  passwordChangedTip: 'เปลี่ยนรหัสผ่านของคุณเรียบร้อยแล้ว',
  error: {
    emailEmpty: 'ต้องระบุที่อยู่อีเมล',
    emailInValid: 'โปรดป้อนที่อยู่อีเมลที่ถูกต้อง',
    nameEmpty: 'ต้องระบุชื่อ',
    passwordEmpty: 'ต้องใช้รหัสผ่าน',
    passwordLengthInValid: 'รหัสผ่านต้องมีอย่างน้อย 8 อักขระ',
    passwordInvalid: 'รหัสผ่านต้องมีตัวอักษรและตัวเลข และความยาวต้องมากกว่า 8',
    registrationNotAllowed: 'ไม่พบบัญชี โปรดติดต่อผู้ดูแลระบบเพื่อลงทะเบียน',
  },
  license: {
    tip: 'ก่อนเริ่ม Dify Community Edition โปรดอ่าน GitHub',
    link: 'ใบอนุญาตโอเพ่นซอร์ส',
  },
  join: 'ต่อ',
  joinTipStart: 'เชิญคุณเข้าร่วม',
  joinTipEnd: 'ทีมงานใน Dify',
  invalid: 'ลิงก์หมดอายุ',
  explore: 'สํารวจ Dify',
  activatedTipStart: 'คุณได้เข้าร่วม',
  activatedTipEnd: 'ทีม',
  activated: 'ลงชื่อเข้าใช้ตอนนี้',
  adminInitPassword: 'รหัสผ่านเริ่มต้นผู้ดูแลระบบ',
  validate: 'ตรวจ สอบ',
  checkCode: {
    checkYourEmail: 'ตรวจสอบอีเมลของคุณ',
    tips: 'เราส่งรหัสยืนยันไปที่ <strong>{{email}}</strong>',
    validTime: 'โปรดทราบว่ารหัสนี้ใช้ได้นาน 5 นาที',
    verificationCode: 'รหัสยืนยัน',
    verificationCodePlaceholder: 'ป้อนรหัส 6 หลัก',
    verify: 'ตรวจสอบ',
    didNotReceiveCode: 'ไม่ได้รับรหัสใช่ไหม',
    resend: 'ส่ง',
    useAnotherMethod: 'ใช้วิธีอื่น',
    emptyCode: 'ต้องใช้รหัส',
    invalidCode: 'รหัสไม่ถูกต้อง',
  },
  resetPassword: 'รีเซ็ตรหัสผ่าน',
  resetPasswordDesc: 'พิมพ์อีเมลที่คุณใช้ลงทะเบียนบน Dify แล้วเราจะส่งอีเมลรีเซ็ตรหัสผ่านให้คุณ',
  backToLogin: 'กลับไปที่เข้าสู่ระบบ',
  setYourAccount: 'ตั้งค่าบัญชีของคุณ',
  enterYourName: 'โปรดป้อนชื่อผู้ใช้ของคุณ',
  back: 'ย้อนกลับ',
  noLoginMethod: 'ไม่ได้กําหนดค่าวิธีการตรวจสอบสิทธิ์',
  noLoginMethodTip: 'โปรดติดต่อผู้ดูแลระบบเพื่อเพิ่มวิธีการรับรองความถูกต้อง',
  licenseExpired: 'ใบอนุญาตหมดอายุ',
  licenseExpiredTip: 'สิทธิ์การใช้งาน Dify Enterprise สําหรับพื้นที่ทํางานของคุณหมดอายุแล้ว โปรดติดต่อผู้ดูแลระบบของคุณเพื่อใช้ Dify ต่อไป',
  licenseLost: 'ใบอนุญาตสูญหาย',
  licenseLostTip: 'เชื่อมต่อเซิร์ฟเวอร์ใบอนุญาต Dify ไม่สําเร็จ โปรดติดต่อผู้ดูแลระบบของคุณเพื่อใช้ Dify ต่อไป',
  licenseInactive: 'ใบอนุญาตไม่ใช้งาน',
  licenseInactiveTip: 'สิทธิ์การใช้งาน Dify Enterprise สําหรับพื้นที่ทํางานของคุณไม่ได้ใช้งาน โปรดติดต่อผู้ดูแลระบบของคุณเพื่อใช้ Dify ต่อไป',
  webapp: {
    noLoginMethodTip: 'กรุณาติดต่อผู้ดูแลระบบเพื่อเพิ่มวิธีการตรวจสอบสิทธิ์.',
    noLoginMethod: 'ไม่ได้กำหนดวิธีการตรวจสอบสิทธิ์สำหรับเว็บแอป',
    disabled: 'การรับรองความถูกต้องของเว็บแอปถูกปิดใช้งาน โปรดติดต่อผู้ดูแลระบบเพื่อเปิดใช้งาน คุณสามารถลองใช้แอปโดยตรงได้',
  },
}

export default translation
